import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Swiper as OriginSwiper, SwiperSlide } from "swiper/react";
import Swiper from "swiper";

import { setLocalValue } from "../../libs/localStorage";

import { useScrollLockContext } from "../../contexts/scrollLockContext";

import BottomButtonGroup from "../Button/Bottom";
import CommonButton from "../Button";

import board1 from "../../assets/img/board1.png";
import board2 from "../../assets/img/board2.png";
import board3 from "../../assets/img/board3.png";
import SandiCi from "../../assets/img/sandi-ci-simple.png";

type Props = {};

export default function OnBoard(props: Props) {
  const [isOpen, setIsOpen] = useState(true);
  const [isHidden, setIsHidden] = useState(false);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [swiper, setSwiper] = useState<Swiper>();

  const [, { lockScroll, unlockScroll }] = useScrollLockContext();

  const boardList: {
    title: React.ReactNode;
    subtitle: string;
    image: string;
  }[] = [
    {
      title: (
        <>
          <span className="font-medium">슬기로운</span>
          <br />
          <span className="font-medium">건물생활</span>의
          <br />
          시작
        </>
      ),
      subtitle: "오피스라이프에 최적화된\n다양한 케어 서비스",
      image: board1,
    },
    {
      title: (
        <>
          지금 이순간!
          <br />
          <span className="font-medium">꼭 필요한 순간에</span>
          <br />
          <span className="font-medium">딱 맞는 서비스</span>
        </>
      ),
      subtitle:
        "건물 내 불편 및 개선 요청부터\n유용한 정보 확인까지 빠르고 편리하게",
      image: board2,
    },
    {
      title: (
        <>
          앱으로 만나는
          <br />
          <span className="font-medium">더 편리하고 스마트한</span>
          <br />
          <span className="font-medium">우리 건물</span>
        </>
      ),
      subtitle: "모바일 환경에 최적화된 서비스로\n스마트하고 편리한 공간 경험",
      image: board3,
    },
  ];

  const handleChange = (swiper: any) => {
    setActiveIndex(swiper.activeIndex);
  };

  useEffect(() => {
    if (isOpen === true) {
      const scrollId = lockScroll?.({});

      return () => {
        unlockScroll?.({ activeElements: [scrollId] });
      };
    }
  }, [isOpen]);

  return (
    <div
      className={clsx([
        "fixed h-screen w-full z-[70] bg-white overflow-y-scroll transition-all",
        {
          "opacity-0": !isOpen,
          hidden: isHidden,
          "pb-20": activeIndex === 2,
          "pb-2": activeIndex !== 2,
        },
      ])}
    >
      <div className="p-[30px] pb-[40px]">
        <img src={SandiCi} className="h-[30px]" alt="sandiCi" />
      </div>

      <OriginSwiper
        onSlideChange={handleChange}
        onSwiper={(swiper) => setSwiper(swiper)}
      >
        {boardList.map((board, index) => (
          <SwiperSlide key={index}>
            <div className="flex flex-col gap-[15px] px-[30px] pb-10">
              <div className="text-[30px] font-light leading-[38px] tracking-[-1.52px]">
                {board.title}
              </div>
              <div className="text-brand-neutral-40 whitespace-pre-line leading-[24px] font-normal">
                {board.subtitle}
              </div>
            </div>
            <div className="w-full items-center">
              <img
                src={board.image}
                alt={`Banner${index}`}
                style={{ objectFit: "cover" }}
                className="w-[100%] mx-auto"
              />
            </div>
          </SwiperSlide>
        ))}
      </OriginSwiper>
      <div className="w-full top-full z-[70] flex gap-1 mt-6 justify-center">
        {boardList?.map((_, index) => (
          <div
            key={index}
            className={`w-[6px] h-[6px] rounded-full ${
              activeIndex === index ? "bg-black" : "bg-gray-300"
            }`}
          ></div>
        ))}
      </div>
      {activeIndex !== 2 && (
        <div className="pt-5">
          <CommonButton
            onClick={() => {
              setActiveIndex(2);
              swiper?.slideTo(2);
            }}
            variant="transparent"
            className="text-base leading-[19px] !text-brand-neutral-40 w-full h-bottom-button"
          >
            건너뛰기
          </CommonButton>
        </div>
      )}

      {activeIndex === 2 && (
        <BottomButtonGroup
          title="지금 시작하기"
          onClick={() => {
            setLocalValue("boarded", "true");
            setIsOpen(false);
            setTimeout(() => setIsHidden(true), 300);
          }}
          className="z-[70]"
          disabled={activeIndex < 2}
        />
      )}
    </div>
  );
}
